import type { ContractSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../../../types'
import {
  fetchModulationLocationEligibleContracts,
  type FetchModulationLocationEligibleContractsOptions
} from '../modulation.contracts.elligible.api'
import { modulationContractsCachekeys } from '../modulation.contracts.elligible.cacheKeys'

export const useFetchModulationLocationEligibleContracts = (
  request: FetchModulationLocationEligibleContractsOptions,
  queryOptions?: UseAppQueryOptions<ContractSchema[]>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: modulationContractsCachekeys.all(request?.queryParams),
    queryFn: () => fetchModulationLocationEligibleContracts(request)
  })
}
